<template>
  <v-layout row wrap>
    <v-flex lg12>
      <v-card class="elevation-15">
        <v-toolbar color="default" class="title font-weight-bold elevation-0 pa-2">
          UNIDAD DE REGISTRO PÚBLICO DE LA ABOGACÍA
        </v-toolbar>
       
        <v-card-text class="pa-3">
          <p class="text-xs-justify">{{this.$store.state.msg.rpa.descripcion}}</p>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex d-flex xl6 lg6 md12 sm12 >
      <Tramite :tramite="registro">
          <template slot="contador" v-if="conteoMatriculado>0">
              <Contador :valor="conteoMatriculado" :descripcion="registro.conteo.descripcion"/>
          </template>
          <template slot="accionesTramite">
             <v-btn color="primary" to="/registro" small round><v-icon class="pr-2">visibility</v-icon> ver requisitos</v-btn>
          </template>
      </Tramite>
    </v-flex>
    <v-flex d-flex xl6 lg6 md12 sm12 >
      <Tramite :tramite="cursos">
      </Tramite>
    </v-flex>
    <v-flex d-flex xl6 lg6 md12 sm12 >
      <Tramite :tramite="ruanna">
          <template slot="contador" v-if="conteoRuanna>0">
              <Contador :valor="conteoRuanna" :descripcion="ruanna.conteo.descripcion"/>
          </template>
      </Tramite>
    </v-flex>
    <v-flex d-flex xl6 lg6 md12 sm12 >
      <Tramite :tramite="control"></Tramite>
    </v-flex>
  </v-layout>
</template>
<script>
import Tramite from "@/components/Inicio/Tramite";
import Contador from "@/components/Inicio/Contador";
export default {
  data() {
    return {
       registro: {
          titulo: "1.- REGISTRO",
          descripcion:
            "Registro de profesionales abogadas, abogados y sociedades civiles.",
          imagen:
            "https://pngimage.net/wp-content/uploads/2018/06/icono-nuevo-registro-png-4.png",
          conteo:{
              descripcion:'Abogadas(os) Matriculadas(os) en RPA'
          },
          acciones:true  
        },

        cursos:{
           titulo:'2.- CURSOS',
            descripcion: 'La Unidad de Registro Público de la Abogacía viene desarrollando continuamente cursos, seminarios y talleres dirigidos a sus afiliados en todo el territorio nacional, difundiendo la práctica y el conocimiento de la ciencia del Derecho.',
            imagen: 'https://geoinnova.org/cursos/wp-content/uploads/2017/07/titulos.png',
        },
        
        ruanna:{
            titulo:'3.- RUANNA',
            descripcion: 'Registro Único de Abogadas, Abogados para la defensa Técnica, Gratuita y Especializada de Niñas, Niños y Adolecentes Víctimas de Delitos de Violencia',
            imagen: 'https://ruanna.justicia.gob.bo/static/img/ruanna.77a5738.png',
            conteo:{
              descripcion:'Abogadas(os) Registradas(os) en RUANNA'
            } 
        },
        
        control:{
            titulo:'4.- CONTROL PROFESIONAL',
            descripcion: 'Registro Único de Abogadas, Abogados para la defensa Técnica, Gratuita y Especializada de Niñas, Niños y Adolecentes Víctimas de Delitos de Violencia',
            imagen: 'https://apirpa2.justicia.gob.bo/imagenes/sanciones.jpg'
        }
      
    };
  },
  computed:{
    conteoRuanna(){
      return this.$store.state.cantidad.ruanna
    },
    conteoMatriculado(){
      return this.$store.state.cantidad.matriculados
    }
  },
  components: {
    Tramite,Contador
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Inicio/Descripcion.vue